import React from 'react';
import { FiBarChart2, FiTrendingUp, FiUsers, FiDollarSign } from 'react-icons/fi';

const Analytics = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Platform Analytics</h2>
        <p className="text-gray-600 mt-2">Comprehensive analytics and insights across all companies</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Revenue</p>
              <p className="text-2xl font-bold text-gray-900">$2.4M</p>
              <p className="text-sm text-green-600">+12% from last month</p>
            </div>
            <FiDollarSign className="text-green-500" size={24} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Active Users</p>
              <p className="text-2xl font-bold text-gray-900">1,247</p>
              <p className="text-sm text-green-600">+8% from last month</p>
            </div>
            <FiUsers className="text-blue-500" size={24} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Conversion Rate</p>
              <p className="text-2xl font-bold text-gray-900">24.3%</p>
              <p className="text-sm text-green-600">+2.1% from last month</p>
            </div>
            <FiTrendingUp className="text-purple-500" size={24} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Avg. Loan Value</p>
              <p className="text-2xl font-bold text-gray-900">$325K</p>
              <p className="text-sm text-red-600">-3% from last month</p>
            </div>
            <FiBarChart2 className="text-orange-500" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4">Analytics Dashboard Coming Soon</h3>
        <p className="text-gray-600">
          Detailed analytics including loan processing times, approval rates, company performance metrics, 
          and more will be available here.
        </p>
      </div>
    </div>
  );
};

export default Analytics;